import registryCoreKit from '@Ravnur-Inc/core/ui-kit';
import Accordion from '@Ravnur-Inc/shared/components/accordion/accordion';
import ActionButton from '@Ravnur-Inc/shared/components/action-button/action-button';
import Alert from '@Ravnur-Inc/shared/components/alert/alert';
import Carousel from '@Ravnur-Inc/shared/components/carousel/carousel.vue';
import Ellipsis from '@Ravnur-Inc/shared/components/ellipsis/ellipsis';
import GridCard from '@Ravnur-Inc/shared/components/grid-card/grid-card';
import Info from '@Ravnur-Inc/shared/components/info/info';
import ListCard from '@Ravnur-Inc/shared/components/list-card/list-card';
import Lookup from '@Ravnur-Inc/shared/components/lookup/lookup';
import Messages from '@Ravnur-Inc/shared/components/messages/messages';
import NamedBlock from '@Ravnur-Inc/shared/components/named-block/named-block';
import Paper from '@Ravnur-Inc/shared/components/paper/paper';
import Placeholder from '@Ravnur-Inc/shared/components/placeholder/placeholder';
import Rating from '@Ravnur-Inc/shared/components/rating/rating.vue';
import SearchInput from '@Ravnur-Inc/shared/components/search-input/search-input';
import StatsButton from '@Ravnur-Inc/shared/components/stats-btn/stats-btn';
import Stats from '@Ravnur-Inc/shared/components/stats/stats';
import Tag from '@Ravnur-Inc/shared/components/tags/tag';
import Tags from '@Ravnur-Inc/shared/components/tags/tags';
import Thumbnail from '@Ravnur-Inc/shared/components/thumbnail/thumbnail';
import { App } from 'vue';

export default function registry(app: App) {
  registryCoreKit(app);
  app.component('accordion', Accordion);
  app.component('action-button', ActionButton);
  app.component('portal-alert', Alert);
  app.component('carousel', Carousel);
  app.component('ellipsis', Ellipsis);
  app.component('grid-card', GridCard);
  app.component('list-card', ListCard);
  app.component('lookup', Lookup);
  app.component('messages', Messages);
  app.component('paper', Paper);
  app.component('placeholder', Placeholder);
  app.component('info', Info);
  app.component('rating', Rating);
  app.component('search-input', SearchInput);
  app.component('stats', Stats);
  app.component('stats-btn', StatsButton);
  app.component('tag', Tag);
  app.component('tags', Tags);
  app.component('thumbnail', Thumbnail);
  app.component('named-block', NamedBlock);
}
